import { observable } from "mobx";

class DefaultStore {
  @observable text = "prksh bhaiya";
}

export default DefaultStore;
